module.exports = __webpack_public_path__ + "img/L_5D.493b63a9.png";